export default __webpack_public_path__ + "static/media/Talent_Slingshot.2ff683a7.png";